/* Forside 2026 – prototypens app.js (site/dist/app.js) tilpasset Shopify: menu fra Shopify (window.JMB_NAV), assets fra temaet, tekster fra window.F26.
   Hver funktion starter for sig og tjekker selv, at dens elementer findes – fjerner HC en sektion, virker resten stadig (punkt 34).
   Når en sektion genindlæses i theme-editoren (shopify:section:load), startes den del igen (punkt 33). */
(() => {
  const NAV = window.JMB_NAV || [];
  const $ = (s, el = document) => (el ? el.querySelector(s) : null);
  const $$ = (s, el = document) => (el ? [...el.querySelectorAll(s)] : []);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const icon = (id, cls = 'ic ic--sm') => `<svg class="${cls}"><use href="#i-${id}"/></svg>`;
  const ext = (url) => (url.startsWith('http') ? ' rel="noopener"' : '');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const T = window.F26 || {};
  const tx = (k, fallback) => (T.t && T.t[k]) || fallback;
  const img = (p) => (!p ? '' : /^(https?:)?\/\//.test(p) ? p : `${T.assets || ''}f26-${p.replace(/\//g, '-')}`);
  /* Binder kun én gang pr. element, selvom en del startes igen */
  const once = (el, key) => { if (!el || el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

  /* ---------- Hovednavigation + megamenu ---------- */
  let openIdx = -1, openTimer, closeTimer;
  const megaHTML = (c) => `
    <div class="wrap mega__in">
      <div class="mega__groups">
        ${c.groups.map((g) => `
          <div class="mega__group">
            <h3><a href="${esc(g.url)}">${esc(g.name)}</a></h3>
            <ul>${g.items.map((it) => `<li><a href="${esc(it.url)}">${esc(it.name)}</a></li>`).join('')}</ul>
          </div>`).join('')}
      </div>
      <a class="mega__feature" href="${esc(c.url)}">
        ${c.image ? `<img src="${esc(img(c.image))}" alt="" width="900" height="600">` : ''}
        <div><strong>${esc(tx('all', 'All %s').replace('%s', c.name.toLowerCase()))}</strong>${c.text ? `<p>${esc(c.text)}</p>` : ''}<span class="link">${esc(tx('seeCategory', 'See the whole category'))} ${icon('arrow')}</span></div>
      </a>
    </div>`;
  function openMega(i) {
    const mega = $('#mega'); if (!mega || !NAV[i]) return;
    clearTimeout(closeTimer);
    if (openIdx === i) return;
    openIdx = i;
    mega.innerHTML = megaHTML(NAV[i]);
    mega.hidden = false;
    $$('.mainnav__btn[data-i]').forEach((b) => b.setAttribute('aria-expanded', String(+b.dataset.i === i)));
  }
  function closeMega() {
    const mega = $('#mega');
    openIdx = -1;
    if (mega) mega.hidden = true;
    $$('.mainnav__btn[data-i]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }
  const scheduleClose = () => { clearTimeout(openTimer); closeTimer = setTimeout(closeMega, 240); };

  /* Menuen må aldrig flyde ind over logo og ikoner. Passer den ikke, strammes den; passer den stadig ikke, vises burger-menuen. */
  function fitNav() {
    const navEl = $('.mainnav'), list = $('#mainnav-list'), root = document.documentElement;
    root.classList.remove('f26-nav-compact', 'f26-nav-burger');
    if (!navEl || !list || getComputedStyle(navEl).display === 'none') return;
    if (list.scrollWidth <= navEl.clientWidth) return;
    root.classList.add('f26-nav-compact');
    if (list.scrollWidth > navEl.clientWidth) root.classList.add('f26-nav-burger');
  }

  function initNav() {
    const list = $('#mainnav-list'), mega = $('#mega'), navEl = $('.mainnav');
    if (!list || !mega || !navEl || !once(list, 'f26Nav')) return;
    /* Menupunktet markeret nodock (fx Shop by Use) ligger i topbaren som »Industries« og vises ikke i hovedmenuen på desktop */
    list.innerHTML = NAV.map((c, i) => c.nodock ? '' : c.external
      ? `<li class="mainnav__item"><a class="mainnav__btn" href="${esc(c.url)}"${ext(c.url)}>${esc(c.name)}</a></li>`
      : `<li class="mainnav__item"><button class="mainnav__btn" type="button" data-i="${i}" aria-expanded="false" aria-controls="mega">${esc(c.name)}${icon('chev', 'ic ic--xs')}</button></li>`
    ).join('');
    list.addEventListener('mouseover', (e) => {
      const b = e.target.closest('.mainnav__btn[data-i]');
      if (!b || !finePointer.matches) return;
      clearTimeout(openTimer); clearTimeout(closeTimer);
      openTimer = setTimeout(() => openMega(+b.dataset.i), openIdx === -1 ? 110 : 0);
    });
    list.addEventListener('click', (e) => {
      const b = e.target.closest('.mainnav__btn[data-i]');
      if (!b) return;
      const i = +b.dataset.i;
      openIdx === i ? closeMega() : openMega(i);
    });
    list.addEventListener('keydown', (e) => {
      const b = e.target.closest('.mainnav__btn[data-i]');
      if (b && e.key === 'ArrowDown') { e.preventDefault(); openMega(+b.dataset.i); $('a', $('#mega'))?.focus(); }
      /* Punkt 39: Tab fra et åbent menupunkt går ind i megamenuen (den ligger efter listen i koden) */
      if (b && e.key === 'Tab' && !e.shiftKey && openIdx === +b.dataset.i && !mega.hidden) {
        const first = $('a', mega); if (first) { e.preventDefault(); first.focus(); }
      }
    });
    /* Tab fra sidste link i megamenuen → næste menupunkt; Shift+Tab fra første → tilbage til menupunktet */
    mega.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const links = $$('a', mega); if (!links.length) return;
      const btn = $(`.mainnav__btn[data-i="${openIdx}"]`);
      if (!e.shiftKey && document.activeElement === links[links.length - 1]) {
        const next = btn?.closest('li')?.nextElementSibling?.querySelector('.mainnav__btn');
        if (next) { e.preventDefault(); closeMega(); next.focus(); } else closeMega();
      } else if (e.shiftKey && document.activeElement === links[0] && btn) { e.preventDefault(); btn.focus(); }
    });
    /* Forlader fokus både menuen og megamenuen, lukkes den */
    const navRoot = navEl.closest('.header') || navEl;
    navRoot.addEventListener('focusout', (e) => {
      if (!e.relatedTarget || (!navEl.contains(e.relatedTarget) && !mega.contains(e.relatedTarget))) closeMega();
    });
    navEl.addEventListener('mouseleave', () => finePointer.matches && scheduleClose());
    mega.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    mega.addEventListener('mouseleave', () => finePointer.matches && scheduleClose());
    fitNav();
    document.fonts?.ready.then(fitNav);
  }

  /* ---------- Mobilmenu ---------- */
  function openDrawer() {
    const drawer = $('#drawer'); if (!drawer) return;
    drawer.hidden = false; $('.header__burger')?.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; $('summary', drawer)?.focus();
  }
  function closeDrawer() {
    const drawer = $('#drawer'); if (!drawer || drawer.hidden) return;
    drawer.hidden = true; $('.header__burger')?.setAttribute('aria-expanded', 'false'); document.body.style.overflow = '';
  }
  function initDrawer() {
    const drawer = $('#drawer'), body = $('#drawer-body'), burger = $('.header__burger');
    if (!drawer || !body || !burger || !once(drawer, 'f26Drawer')) return;
    const extra = tx('drawer', ['Industries', 'About us', 'Customer service', 'Contact and quote']);
    body.innerHTML = NAV.map((c) => c.external
      ? `<a href="${esc(c.url)}"${ext(c.url)}>${esc(c.name)}${icon('arrow')}</a>`
      : `<details><summary>${esc(c.name)}${icon('chev')}</summary><div class="dgroup">
          <a class="all" href="${esc(c.url)}">${esc(tx('seeAll', 'See all %s').replace('%s', c.name.toLowerCase()))}</a>
          ${c.groups.map((g) => `<a href="${esc(g.url)}">${esc(g.name)}</a>`).join('')}
        </div></details>`).join('') +
      `<div class="drawer__extra">${[['#segments', 0], [T.about || '/pages/about-us', 1], ['#customer-support', 2], ['#contact', 3]].map(([h, i]) => `<a href="${esc(h)}">${esc(extra[i])}</a>`).join('')}</div>`;
    burger.addEventListener('click', openDrawer);
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer || e.target.closest('[data-close-drawer]') || e.target.closest('.drawer__extra a')) closeDrawer();
    });
  }

  /* ---------- Land/område og butik ---------- */
  function closeLocale() { const p = $('#locale-pop'); if (p) p.hidden = true; $('.locale__btn')?.setAttribute('aria-expanded', 'false'); }
  function initLocale() {
    const btn = $('.locale__btn'), pop = $('#locale-pop');
    if (!btn || !pop || !once(btn, 'f26Locale')) return;
    btn.addEventListener('click', () => { const o = pop.hidden; pop.hidden = !o; btn.setAttribute('aria-expanded', String(o)); });
  }

  /* ---------- Søgning: Shopify Predictive Search + menupunkter ---------- */
  const index = [];
  NAV.forEach((c) => {
    if (c.external) return;
    index.push({ title: c.name, sub: tx('category', 'Category'), url: c.url, image: c.image, rank: 0 });
    c.groups.forEach((g) => {
      index.push({ title: g.name, sub: c.name, url: g.url, image: c.image, rank: 1 });
      g.items.forEach((it) => index.push({ title: it.name, sub: `${g.name} · ${c.name}`, url: it.url, image: c.image, rank: 2 }));
    });
  });
  const norm = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/å/g, 'a');
  const shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = (v) => { try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(Number(v)); } catch (e) { return v; } };
  const cleanUrl = (u) => u.split('?')[0];
  let searchCtrl, searchTimer, active = -1;
  async function predictive(term) {
    searchCtrl?.abort(); searchCtrl = new AbortController();
    const url = `${shopRoot}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`;
    try {
      const r = await fetch(url, { signal: searchCtrl.signal });
      if (!r.ok) return [];
      const res = (await r.json()).resources.results;
      return [
        ...(res.products || []).map((p) => ({ title: p.title, sub: p.price ? money(p.price) : tx('product', 'Product'), url: cleanUrl(p.url), image: p.image || p.featured_image?.url || '' })),
        ...(res.collections || []).map((c) => ({ title: c.title, sub: tx('category', 'Category'), url: cleanUrl(c.url), image: c.featured_image?.url || '' })),
      ];
    } catch (e) { return []; }
  }
  function closeSearch() {
    const q = $('#q'), results = $('#search-results'); if (!q || !results) return;
    results.hidden = true; q.setAttribute('aria-expanded', 'false'); q.removeAttribute('aria-activedescendant');
  }
  function renderSearch() {
    const q = $('#q'), results = $('#search-results'); if (!q || !results) return;
    const term = q.value.trim();
    if (term.length < 2) { closeSearch(); return; }
    clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      const words = norm(term).split(/\s+/);
      const menuHits = index
        .filter((r) => { const hay = norm(`${r.title} ${r.sub}`); return words.every((w) => hay.includes(w)); })
        .sort((a, b) => a.rank - b.rank || (norm(a.title).startsWith(words[0]) ? -1 : 1));
      const shopHits = await predictive(term);
      if (q.value.trim() !== term) return; /* brugeren har skrevet videre */
      const seen = new Set();
      const hits = [...shopHits, ...menuHits]
        .filter((r) => { const k = cleanUrl(r.url); if (seen.has(k)) return false; seen.add(k); return true; })
        .slice(0, 8);
      const mark = (s) => { const out = esc(s); const w = esc(term); const i = out.toLowerCase().indexOf(w.toLowerCase()); return i < 0 ? out : out.slice(0, i) + '<mark>' + out.slice(i, i + w.length) + '</mark>' + out.slice(i + w.length); };
      results.innerHTML = hits.length
        ? hits.map((r, i) => `<a href="${esc(r.url)}" role="option" id="sr-${i}" aria-selected="false">${r.image ? `<img src="${esc(img(r.image))}" alt="" loading="lazy">` : '<span class="ph"></span>'}<span><strong>${mark(r.title)}</strong><small>${esc(r.sub)}</small></span></a>`).join('')
        : `<p class="search__empty">${esc(tx('noMatch', 'No match for “%s”. Press Enter to search the whole shop.').replace('%s', term))}</p>`;
      results.hidden = false; q.setAttribute('aria-expanded', 'true'); active = -1;
    }, 180);
  }
  function toggleSearchBar(open) {
    const bar = $('#search-bar'), toggle = $('.header__searchtoggle'); if (!bar) return;
    if (open === undefined) open = bar.hidden;
    bar.hidden = !open;
    toggle?.setAttribute('aria-expanded', String(open));
    if (open) { closeMega(); $('#q')?.focus(); } else { closeSearch(); }
  }
  function initSearch() {
    const q = $('#q'), results = $('#search-results'), toggle = $('.header__searchtoggle');
    if (!q || !results || !once(q, 'f26Search')) return;
    q.addEventListener('input', renderSearch);
    q.addEventListener('focus', () => q.value.trim().length > 1 && renderSearch());
    q.addEventListener('keydown', (e) => {
      const opts = $$('[role="option"]', results);
      if (!opts.length || results.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach((o, i) => o.setAttribute('aria-selected', String(i === active)));
        q.setAttribute('aria-activedescendant', opts[active].id);
      } else if (e.key === 'Enter' && active > -1) { e.preventDefault(); location.href = opts[active].href; }
    });
    toggle?.addEventListener('click', () => toggleSearchBar());
    $('.searchbar__close')?.addEventListener('click', () => { toggleSearchBar(false); toggle?.focus(); });
  }

  /* ---------- Sticky header (skygge når siden er scrollet) ---------- */
  const onScroll = () => { const h = $('.f26p .header'); if (h) h.classList.toggle('is-stuck', scrollY > ($('.topbar')?.offsetHeight || 0) + 4); };

  /* ---------- Produkt-rækken i heroen ---------- */
  function initDock() {
    const dock = $('#finder-dock'), info = $('#finder-info');
    if (!dock || !info || !once(dock, 'f26Dock')) return;
    /* Har hero-sektionen cirkel-blokke (data-f26-static), er rækken og infolinjerne allerede tegnet i Liquid; ellers bygges de fra menuen som i prototypen */
    if (!dock.hasAttribute('data-f26-static')) {
      const cats = NAV.filter((c) => !c.external && !c.nodock);
      dock.style.setProperty('--cols', cats.length);
      dock.innerHTML = cats.map((c, i) => `<li class="dk__item"><a href="${esc(c.url)}" data-i="${i}"><span class="dk__img"><img src="${esc(img(c.image))}" alt="" width="900" height="600"></span><span class="dk__name">${esc(c.name)}</span></a></li>`).join('');
      info.innerHTML = `<p class="dk__line is-on">${esc(tx('hoverHint', 'Hover over a category to see what it contains – or click to see everything.'))}</p>` +
        cats.map((c) => `<p class="dk__line"><strong>${esc(c.name)}:</strong> ${c.groups.map((g) => esc(g.name)).join(' · ')}</p>`).join('');
    }
    const showLine = (i) => $$('.dk__line', info).forEach((l, k) => l.classList.toggle('is-on', k === i));
    const fromEvent = (e) => e.target.closest('a[data-i]');
    dock.addEventListener('mouseover', (e) => { const a = fromEvent(e); if (a) showLine(+a.dataset.i + 1); });
    dock.addEventListener('focusin', (e) => { const a = fromEvent(e); if (a) showLine(+a.dataset.i + 1); });
    dock.addEventListener('mouseleave', () => { if (!dock.contains(document.activeElement)) showLine(0); });
    dock.addEventListener('focusout', (e) => { if (!dock.contains(e.relatedTarget)) showLine(0); });
  }

  /* ---------- Tilbud: valider før Shopifys kontaktformular sender ---------- */
  function initQuote() {
    const form = $('#qform');
    if (!form || !once(form, 'f26Quote')) return;
    const status = $('#qform-status', form);
    form.addEventListener('submit', (e) => {
      let bad = null;
      $$('[required]', form).forEach((f) => { const ok = f.value.trim() && (f.type !== 'email' || /.+@.+\..+/.test(f.value)); f.setAttribute('aria-invalid', String(!ok)); if (!ok && !bad) bad = f; });
      if (bad) { e.preventDefault(); if (status) { status.className = 'qform__status is-error'; status.textContent = tx('required', 'Please fill in the highlighted fields.'); } bad.focus(); return; }
      if (status) { status.className = 'qform__status'; status.textContent = tx('sending', 'Sending your request …'); }
      $('[type="submit"]', form)?.setAttribute('disabled', '');
    });
    form.addEventListener('input', (e) => e.target.getAttribute('aria-invalid') === 'true' && e.target.value.trim() && e.target.setAttribute('aria-invalid', 'false'));
    const done = $('.qform__done', form);
    if (done) setTimeout(() => done.focus({ preventScroll: false }), 300);
  }

  /* ---------- Kunder: review-væg (bygget af anmeldelserne længere nede) + logobånd ---------- */
  const initials = (n) => n.replace(/\./g, '').split(/\s+/).map((w) => w[0] || '').join('').slice(0, 2).toUpperCase();
  const wallCard = (r) => `<figure class="wc"><div class="wc__top"><span class="wc__av">${esc(initials(r.name))}</span><span><strong>${esc(r.name)}</strong><small>${esc(r.date)}</small></span></div><p class="wc__t">${esc(r.title)}</p><p class="wc__b">${esc(r.body)}</p></figure>`;
  function initWall() {
    const wallEl = $('#review-wall');
    if (!wallEl) return;
    const reviews = $$('#reviews-track .review:not([aria-hidden])').map((r) => {
      const [name = '', date = ''] = ($('footer', r)?.textContent || '').split('·').map((x) => x.trim());
      return { name, date, title: $('h3', r)?.textContent || '', body: $('p', r)?.textContent || '' };
    });
    if (!reviews.length) { wallEl.innerHTML = ''; return; } /* uden anmeldelser er væggen tom (fx hvis sektionen er fjernet) */
    const nCols = Math.min(16, Math.ceil((Math.max(innerWidth, 900) * 1.25) / 236) + 1);
    const cols = Array.from({ length: nCols }, (_, k) => {
      const shift = (k * 3) % reviews.length;
      const cards = reviews.slice(shift).concat(reviews.slice(0, shift)).map(wallCard).join('');
      return `<div class="wall__col${k % 2 ? ' wall__col--rev' : ''}"><div class="wall__track">${cards}${cards}</div></div>`;
    }).join('');
    wallEl.innerHTML = `<div class="wall__tilt">${cols}</div>`;
  }
  /* ---------- USP-båndet kører selv i en løkke på mobil (Jonas 23.10: ingen trækker sidelæns på iPhone) ---------- */
  function initUsps() {
    const list = $('.f26p .usps__list');
    if (!list || calm || window.Shopify?.designMode || !once(list, 'f26Usps') || list.children.length < 2) return;
    list.insertAdjacentHTML('beforeend', list.innerHTML.replace(/<li(?=[\s>])/g, '<li aria-hidden="true" data-f26-copy'));
    list.closest('.usps')?.classList.add('is-running'); /* kopierne og bevægelsen vises kun på mobil (f26-overrides.css) */
  }
  function initLogos() {
    const logoTrack = $('#logo-track');
    if (!logoTrack || calm || !once(logoTrack, 'f26Logos') || !logoTrack.children.length) return;
    const set = logoTrack.innerHTML;
    const copy = set.replace(/<li(?=[\s>])/g, '<li aria-hidden="true"').replace(/alt="[^"]*"/g, 'alt=""');
    logoTrack.innerHTML = set + copy + copy + copy;
    logoTrack.closest('.lm')?.classList.add('is-running');
  }

  /* ---------- Video (indlæses først ved klik) ---------- */
  function initVideo() {
    const btn = $('[data-video]');
    if (!btn || !once(btn, 'f26Video')) return;
    btn.addEventListener('click', (e) => {
      const id = e.currentTarget.dataset.video, box = $('#video');
      if (id && box) box.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0" title="${esc(e.currentTarget.textContent.trim() || 'Video')}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
    });
  }

  /* ---------- Fælles: Escape, klik udenfor, »Get a free quote«-forudfyldning (bindes kun én gang) ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (openIdx > -1) { const b = $(`.mainnav__btn[data-i="${openIdx}"]`); closeMega(); b?.focus(); }
    closeSearch(); closeLocale(); closeDrawer();
    const bar = $('#search-bar');
    if (bar && !bar.hidden) { toggleSearchBar(false); $('.header__searchtoggle')?.focus(); }
  });
  document.addEventListener('click', (e) => {
    if (openIdx > -1 && !e.target.closest('.mainnav, #mega')) closeMega();
    if (!e.target.closest('.locale')) closeLocale();
    if (!e.target.closest('.search')) closeSearch();
    const a = e.target.closest('[data-quote]');
    const form = $('#qform');
    if (a && form) {
      const cat = a.dataset.quote, msg = $('[data-f="besked"]', form);
      if (cat && msg && !msg.value) msg.value = tx('prefill', 'We would like a quote for %s. ').replace('%s', cat.toLowerCase());
      setTimeout(() => $('[data-f="firma"]', form)?.focus({ preventScroll: true }), 500);
    }
  });
  let fitTimer;
  addEventListener('resize', () => { clearTimeout(fitTimer); fitTimer = setTimeout(fitNav, 100); });
  addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Start (og genstart når HC ændrer en sektion i editoren) ---------- */
  /* ---------- Progresslinje under headeren (punkt 16) – på alle sider, uden GSAP ---------- */
  let progressTick = false;
  const drawProgress = () => {
    progressTick = false;
    const bar = $('.f26p .progress'); if (!bar) return;
    const max = document.documentElement.scrollHeight - innerHeight;
    bar.style.transform = `scaleX(${max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0})`;
  };
  function initProgress() {
    if (!$('.f26p .progress')) return;
    document.documentElement.classList.add('has-progress');
    if (once(document.documentElement, 'f26Progress')) {
      addEventListener('scroll', () => { if (!progressTick) { progressTick = true; requestAnimationFrame(drawProgress); } }, { passive: true });
      addEventListener('resize', drawProgress);
    }
    drawProgress();
  }

  /* ---------- Kurv-antal: Shopify skriver det nye antal i #cart-icon-bubble; vi viser det i badget ---------- */
  function setCartCount(n) {
    const a = $('.f26p .header__ic[href$="/cart"]') || $('.f26p .header__ic .badge')?.parentElement; if (!a) return;
    const badge = $('.badge', a); if (badge) badge.textContent = n;
  }
  /* Edition, Zakeke og andre apps lægger i kurv direkte via /cart/add.js uden at opdatere headeren.
     Derfor lyttes der på alle kurv-kald (fetch og XHR); bagefter hentes det rigtige antal fra /cart.js. */
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const rawFetch = window.fetch.bind(window);
  let cartTimer;
  const refreshCart = () => {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(() => {
      rawFetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin' })
        .then((r) => r.json()).then((c) => setCartCount(c.item_count)).catch(() => {});
    }, 150);
  };
  const isCartUrl = (u) => { try { return CART_RE.test(new URL(u, location.href).pathname); } catch (e) { return false; } };
  if (!window.__f26CartWatch) {
    window.__f26CartWatch = true;
    window.fetch = function (input, init) {
      const p = rawFetch(input, init);
      const u = typeof input === 'string' ? input : input?.url;
      if (u && isCartUrl(u)) p.then((r) => { if (r.ok) refreshCart(); }).catch(() => {});
      return p;
    };
    const open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      if (u && isCartUrl(String(u))) this.addEventListener('load', () => { if (this.status < 400) refreshCart(); });
      return open.apply(this, arguments);
    };
  }

  function initCart() {
    const sink = $('#cart-icon-bubble');
    if (sink && once(sink, 'f26Cart')) {
      new MutationObserver(() => {
        const n = parseInt($('.cart-count-bubble [aria-hidden]', sink)?.textContent || '0', 10) || 0;
        setCartCount(n);
      }).observe(sink, { childList: true, subtree: true });
    }
    /* Tilbage-knappen kan vise en gemt side med gammelt antal */
    if (once(document.documentElement, 'f26CartShow')) {
      addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });
    }
  }

  /* ---------- Pause for logobånd og anmeldelsesvæg (punkt 45) ---------- */
  function initMotionPause() {
    $$('.f26p .proof__pause').forEach((b) => {
      if (!once(b, 'f26Pause')) return;
      b.addEventListener('click', () => {
        const paused = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', String(paused));
        b.setAttribute('aria-label', paused ? b.dataset.labelPlay : b.dataset.labelPause);
        b.closest('.proof')?.classList.toggle('is-paused', paused);
        $('use', b)?.setAttribute('href', paused ? '#i-play' : '#i-pause');
      });
    });
  }

  function initAll() {
    [initMotionPause, initNav, initDrawer, initLocale, initSearch, initDock, initQuote, initLogos, initUsps, initWall, initVideo, initProgress, initCart].forEach((fn) => {
      try { fn(); } catch (err) { console.error('[f26]', fn.name, err); } /* én fejl må ikke stoppe resten */
    });
    onScroll();
  }
  initAll();
  /* HC 23.10: ankrene hedder nu engelsk (#contact, #segments, #customer-support …). Gamle danske links (fx gemt eller delt
     /#kontakt) virker stadig: de sendes videre til det nye anker. */
  const OLD_IDS = { kontakt: 'contact', brancher: 'segments', kundeservice: 'customer-support', kategorier: 'products', produktfinder: 'product-finder' };
  const oldHash = OLD_IDS[decodeURIComponent(location.hash.slice(1))];
  if (oldHash && document.getElementById(oldHash)) {
    history.replaceState(null, '', '#' + oldHash);
    const go = () => document.getElementById(oldHash)?.scrollIntoView();
    requestAnimationFrame(go);
    addEventListener('load', go, { once: true }); /* igen, når billederne har sat sig */
  }
  /* Topbarens og mobilmenuens links til forsidens sektioner (#segments, #contact …) skal også virke fra undersider (R09):
     findes målet ikke på siden, går linket til forsiden med samme anker. Kun vores egne links (.f26p). */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.f26p a[href^="#"]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const raw = decodeURIComponent(a.getAttribute('href').slice(1));
    const id = OLD_IDS[raw] || raw; /* et gammelt dansk anker i et editor-felt går til det nye */
    if (!id) return;
    const target = document.getElementById(id);
    if (target && id === raw) return; /* almindeligt anker på siden: browseren klarer det */
    e.preventDefault();
    if (target) { target.scrollIntoView({ behavior: 'smooth' }); history.replaceState(null, '', '#' + id); return; }
    location.href = (window.F26?.root || '/') + '#' + encodeURIComponent(id);
  });
  /* Søgning på ingenting (Jonas 23.10): Enter i et tomt søgefelt gør ingenting – feltet får bare fokus.
     Gælder alle søgeformularer (headerens søgning og søgesidens felt). */
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !/\/search\/?$/.test(new URL(form.action, location.href).pathname)) return;
    const q = form.querySelector('input[name="q"]');
    if (q && !q.value.trim()) { e.preventDefault(); q.value = ''; q.focus(); }
  }, true);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', () => setTimeout(initWall, 0)); /* væggen bygges om, når anmeldelser fjernes */
})();
